var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivemedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1887_16538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.795 17.2051L21.5145 14.4856C22.3117 13.6997 22.9456 12.7639 23.3795 11.732C23.8135 10.7 24.039 9.59244 24.043 8.47299C24.047 7.35354 23.8295 6.24436 23.4029 5.20934C22.9764 4.17433 22.3493 3.23395 21.5577 2.44238C20.7661 1.6508 19.8257 1.02368 18.7907 0.597137C17.7557 0.170596 16.6465 -0.046932 15.5271 -0.0429141C14.4076 -0.0388961 13.3001 0.186588 12.2681 0.620548C11.2362 1.05451 10.3004 1.68836 9.51448 2.4856L6.79498 5.2051L18.795 17.2051ZM17.205 18.7951L5.20498 6.7951L2.48548 9.5146C1.68824 10.3005 1.05439 11.2363 0.620426 12.2683C0.186466 13.3002 -0.0390182 14.4078 -0.0430362 15.5272C-0.0470541 16.6467 0.170474 17.7558 0.597015 18.7909C1.02356 19.8259 1.65068 20.7663 2.44225 21.5578C3.23383 22.3494 4.17421 22.9765 5.20922 23.4031C6.24423 23.8296 7.35342 24.0471 8.47287 24.0431C9.59232 24.0391 10.6999 23.8136 11.7318 23.3797C12.7638 22.9457 13.6996 22.3118 14.4855 21.5146L17.205 18.7951Z",
    fill: "#6D5FF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1887_16538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivemedication);
export default __webpack_public_path__ + "static/media/activemedication.1c344d97117d7f352ced5155c1290893.svg";
export { ForwardRef as ReactComponent };